import router from './router'
import store from './store'
import { ElMessage } from 'element-plus'

// 路由前置守卫：兼容Vuex + sessionStorage持久化
router.beforeEach(async (to, from, next) => {
    const requiresAuth = to.meta.requiresAuth // 是否需要登录权限
    const isLoginPage = to.path === '/yy2126/login' // 登录页路径

    // 核心：优先从sessionStorage获取登录状态（解决刷新后Vuex清空问题）
    const sessionToken = sessionStorage.getItem('token')
    const sessionIsLogin = sessionStorage.getItem('isLogin') === 'true'
    const sessionIsAdmin = sessionStorage.getItem('isAdmin') === 'true'
    // 最终登录状态：Vuex有则用Vuex，无则用sessionStorage
    const isAdminLogin = store.getters.isAdminLogin || (sessionIsLogin && sessionIsAdmin && sessionToken)

    // 场景1：已登录用户访问登录页 → 强制跳后台首页
    if (isLoginPage && isAdminLogin) {
        ElMessage.info('您已登录，无需重复登录')
        next('/yy2126')
        return
    }

    // 场景2：未登录用户访问需权限页面 → 跳登录页
    if (requiresAuth && !isAdminLogin) {
        next({
            path: '/yy2126/login',
            query: { redirect: to.fullPath }
        })
        ElMessage.warning('请先登录管理员账号')
        return
    }

    // 场景3：已登录（sessionStorage有状态但Vuex无）→ 恢复Vuex状态
    if (requiresAuth && isAdminLogin && !store.getters.isAdminLogin) {
        try {
            // 1. 恢复Vuex的token和登录状态
            await store.dispatch('login', { access_token: sessionToken })
            // 2. 恢复用户信息（优先从sessionStorage读取，无则调接口）
            if (!Object.keys(store.state.userInfo).length) {
                await store.dispatch('getUserInfo')
            }
        } catch (error) {
            // 恢复失败：清空状态并跳登录页
            await store.dispatch('logout')
            next({
                path: '/yy2126/login',
                query: { redirect: to.fullPath }
            })
            ElMessage.error('登录状态失效，请重新登录')
            return
        }
    }

    // 其他场景放行
    next()
})

export default router